import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * When new widget is focused on, we immediately load its preview
 */
export const requestPreviewForCurrentWidget = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asObservable.pipe(
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(id =>
          feature.actions.preview.request
            .from('requestPreviewForCurrentWidget (effect)')
            .create({
              flexibleIdentifier: { id },
            }),
        ),
      ),
)
